import React from 'react';
import {Bar, BarChart, ResponsiveContainer, CartesianGrid, Tooltip, XAxis, YAxis} from "recharts";
import TextWrapTick from './TextWrapTick';

export default function BarGraph({title, data, dataKey = "count", tooltipFormatter = null, onClick = null}) {

    const margin = {top: 5, right: 30, left: 20, bottom: 5};

    return (
        <div className="card chart-container">
            <h5 className="chart-title">{title}</h5>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart
                    data={data}
                    margin={margin}
                    height={300}
                >
                    <CartesianGrid vertical={false} stroke="#f5f5f5"/>
                    <XAxis dataKey="step_name" interval={0} tick={<TextWrapTick fontSize={10} width={150} />}/>
                    <YAxis tick={{fontSize: 12}}/>
                    <Tooltip formatter={tooltipFormatter} cursor={{fill: 'transparent'}}/>
                    <Bar dataKey={dataKey}
                         maxBarSize={75}
                         stroke="#8884d8"
                         fill="rgba(136,132,216, 0.50)"
                         onClick={(o, index, event) => {
                             onClick && onClick(o.payload);
                         }}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
